// @flow
import React from 'react'
import { DocInput } from 'components/DocInput'
import FormButtons from 'components/FormButtons'
import Ticket from 'components/Ticket'
import verificationDocLabels from 'lib/verificationDocLabels'
import Reference from './Reference'
import styles from './styles'

type Props = {
  dispatch: Function,
  errors: Object,
  isSubmitting: boolean,
  onChange: Function,
  onSubmit: Function,
  ticket: Object,
  values: Object,
}

export const VerificationStation = (props: Props) => {
  const { errors, isSubmitting, onChange, onSubmit, ticket, values } = props
  const header = {
    subheader: 'Account Creation',
    title: 'Verification',
  }
  const reference = ticket && <Reference {...props} />
  const docLabels = verificationDocLabels(ticket.grantor_relationship)

  return (
    <Ticket header={header} reference={reference}>
      <h5 className={styles.infoText}>Upload the required grantor verification documents.</h5>
      <form className={styles.form} onSubmit={onSubmit}>
        <section className={styles.cardMarginBot}>
          <section className={styles.sectionNoMargin}>
            <DocInput
              errorMessage={errors.primary_grantor_doc_id}
              label={docLabels.primary}
              name="primary_grantor_doc"
              onChange={onChange}
              value={values.primary_grantor_doc}
            />
            <DocInput
              errorMessage={errors.secondary_grantor_doc_id}
              label={docLabels.secondary}
              name="secondary_grantor_doc"
              onChange={onChange}
              value={values.secondary_grantor_doc}
            />
          </section>
        </section>
        <FormButtons submitLabel="Save & Continue" submitting={isSubmitting} />
      </form>
    </Ticket>
  )
}
